import { Position } from "@xyflow/react";
import { Tags } from "lucide-react";
import { BaseHandle } from "../../components/base-handle";
import { BaseNode, BaseNodeContent } from "../../components/base-node";
import { ContextualTipsTrigger } from "@babackapp/ui/components/contextual-tips";
import { useTranslation } from "react-i18next";

export const MODIFY_ORDER_TAGS_NODE_WIDTH = 250;
export const MODIFY_ORDER_TAGS_NODE_HEIGHT_ESTIMATION = 120;

export function ModifyOrderTagsActionNodeEditor({ id }: any) {
  const { t } = useTranslation("trackoffice");

  return (
    <ContextualTipsTrigger
      tips={[
        {
          id: "workflow-node-modify-order-tags",
          Icon: Tags,
          title: t(
            "workflowsEditor.tips.workflowNodeModifyOrderTags.title",
            "This is a modify order tags action node",
          ),
          description: t(
            "workflowsEditor.tips.workflowNodeModifyOrderTags.desc",
            "This node will add or remove internal tags on the order.",
          ),
        },
      ]}
    >
      <BaseNode nodeId={id} style={{ position: "relative" }}>
        <BaseNodeContent>
          <div className="flex flex-col gap-2 w-full">
            <div className="flex flex-col">
              <span className="text-xs text-muted-foreground">
                {t("workflowsEditor.modifyOrderTagsNode.action", "Action")}
              </span>
              <span className="text-xs mt-1 font-semibold">
                {t(
                  "workflowsEditor.modifyOrderTagsNode.title",
                  "Modify Order Tags",
                )}
              </span>
            </div>
          </div>
          <BaseHandle type="target" position={Position.Left} />
          <BaseHandle
            type="source"
            position={Position.Right}
            style={{ top: "50%", transform: "translateY(-50%)" }}
          />
        </BaseNodeContent>
      </BaseNode>
    </ContextualTipsTrigger>
  );
}
